import { defineStore } from 'pinia'
import type { ExpandersSetAction, ExpandersState } from '@/types/expander-types'

export const useExpandersStore = defineStore('expanders', {
  state: (): ExpandersState => ({
    expanders: {},
  }),

  getters: {
    isExpanded: (state: ExpandersState) => (id: string) => {
      return !!(state.expanders && state.expanders[id])
    },
  },

  actions: {
    // set the state of an expanded id
    // must be new object to be reactive
    setExpanded({ id, expanded, collapseAll }: ExpandersSetAction) {
      if (collapseAll) {
        this.expanders = {
          [id]: expanded,
        }
        return
      }

      this.expanders = {
        ...this.expanders,
        [id]: expanded,
      }
    },

    expandIds(ids: string[]) {
      const expanded = {} as Record<string, boolean>

      ids.map((id: string) => {
        expanded[id] = true
      })

      this.expanders = {
        ...this.expanders,
        ...expanded,
      }
    },

    collapseIds(ids: string[]) {
      const expanded = {} as Record<string, boolean>

      ids.map((id: string) => {
        expanded[id] = false
      })

      this.expanders = {
        ...this.expanders,
        ...expanded,
      }
    },

    reset() {
      this.expanders = {}
    },
  },
})
